// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1947":"bfbe917d","2246":"d75a9e35","3146":"79af04af","3355":"3f613b92","6065":"d75a9e35","6575":"d75a9e35","9233":"d75a9e35"}[chunkId] + ".chunk.css";
};